"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAvailable = isAvailable;
exports.getAvailableData = getAvailableData;
function isAvailable(source) {
    return (source === null || source === void 0 ? void 0 : source.status) === "available";
}
function getAvailableData(source) {
    return isAvailable(source) ? source.data : undefined;
}
